import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const ButtonListWrapper = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    width: 105px;
    overflow: auto;

    scrollbar-width: none;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
    
    @media only screen and (min-width: 768px) {
      width: ${displayState?.fullWidth ? 'calc(100% - 50px)' : '165px'};
    }
  `}
`;

export default Wrapper(ButtonListWrapper);